// JWT 디코드 유틸 — 서명 검증은 하지 않는다 (서버가 검증). 클라이언트 UI 판단용.

/**
 * JWT payload 의 `exp`(만료 시각, epoch 초)를 반환한다.
 * 디코드 실패 또는 `exp` 부재 시 null.
 */
export function getTokenExp(token: string): number | null {
  try {
    const payload = token.split('.')[1];
    if (!payload) return null;
    const base64 = payload.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
        .join(''),
    );
    const exp = (JSON.parse(json) as { exp?: unknown }).exp;
    return typeof exp === 'number' ? exp : null;
  } catch {
    return null;
  }
}

/**
 * 토큰이 만료되었거나 `skewSeconds` 이내에 만료될 예정이면 true.
 * 디코드 불가 토큰도 true (안전하게 만료 취급).
 */
export function isTokenExpiringSoon(token: string, skewSeconds = 60): boolean {
  const exp = getTokenExp(token);
  if (exp === null) return true;
  return exp - Date.now() / 1000 < skewSeconds;
}
